import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
});



/* ----------------------------------
  　慣性スクロール
---------------------------------- */

// const lenis = new Lenis();
// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);

/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.hd_fixed');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});




/* ----------------------------------
  スムーススクロール
---------------------------------- */
$(function () {
  function getHeaderHeight(isPageLoad) {
    // ページ読み込み時（#がある場合）とそれ以外でヘッダー高さを変更
    if (isPageLoad) {
      // ページ読み込み時（#がある場合）は、異なる高さを設定
      return window.innerWidth <= 768 ? 70 : 150;  // スマホの場合の高さ調整
    } else {
      // それ以外の場合（クリック時）は通常のヘッダー高さ
      return window.innerWidth <= 768 ? 70 : $('.is_fixed').outerHeight() || 150;
    }
    
  }

  // ページ内リンクをクリックしたとき：アニメーション付き
  $('a[href*="#"]').click(function () {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      const hash = this.hash;
      const $target = $(hash);
      if ($target.length) {
        const position = $target.offset().top - getHeaderHeight(false);
        $("html, body").animate({ scrollTop: position }, 600, "swing");
        return false;
      }
    }
  });

  // ページ読み込み時：アニメーションなしで即移動
  if (location.hash) {
    const $target = $(location.hash);
    if ($target.length) {
      const position = $target.offset().top - getHeaderHeight(true);
      $(window).scrollTop(position); // ← アニメーションなしで即スクロール
    }
  }
});


/* ----------------------------------
　humberger menu
---------------------------------- */
const nav = document.querySelector('.hd_fixed_nav');
const btn = document.querySelector('.hd_menu-toggle'); // 開閉ボタン

let bubbleInterval; // 泡管理用

function startBubbles() {
  const bubblesContainer = document.querySelector(".nav-bubbles");

  bubbleInterval = setInterval(() => {
    const bubbleCount = 2 + Math.floor(Math.random() * 2); // 2〜3個

    for (let i = 0; i < bubbleCount; i++) {
      const bubble = document.createElement("div");
      bubble.classList.add("bubble");

      // 📱 画面幅に応じてサイズと線の太さを切り替え
      const isSp = window.innerWidth <= 768;
      const sizes = isSp ? [40, 80] : [60, 116];
      const borderWidth = isSp ? 5 : 10;

      const size = sizes[Math.floor(Math.random() * sizes.length)];

      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      bubble.style.left = `${Math.random() * 100}%`;
      bubble.style.animationDuration = `${4 + Math.random() * 2}s`;
      bubble.style.border = `${borderWidth}px solid #b9e4ffd5`;

      bubblesContainer.appendChild(bubble);

      // 終了後削除
      setTimeout(() => bubble.remove(), 6000);
    }
  }, 1500);
}

function stopBubbles() {
  clearInterval(bubbleInterval);
}

btn.addEventListener('click', () => {
  if (nav.classList.contains('is_open')) {
    // → 閉じる処理
    nav.classList.remove('is_open');
    nav.classList.add('is_closing');
    btn.classList.remove('is_open');

    // 泡停止
    stopBubbles();

    // アニメーション終了後に完全に閉じる
    setTimeout(() => {
      nav.classList.remove('is_closing');
    }, 500);

  } else {
    // → 開く処理
    nav.classList.add('is_open');
    btn.classList.add('is_open');

    // 泡スタート
    startBubbles();
  }
});






/* ----------------------------------
　HOME　ヘッダー出現
---------------------------------- */ 
document.addEventListener('DOMContentLoaded', () => {
  // front-page.php だけで動作
  if (document.body.classList.contains('index')) {
    const hdFixed = document.querySelector('.hd_fixed');
    const indexMv = document.querySelector('.index_mv');

    if (hdFixed && indexMv) {
      window.addEventListener('scroll', () => {
        const mvHeight = indexMv.offsetHeight;
        const scrollY = window.scrollY;

        if (scrollY > mvHeight) {
          hdFixed.classList.add('is-show');
        } else {
          hdFixed.classList.remove('is-show');
        }
      });
    }
  }
});




/* ----------------------------------
　bubble　アニメーション
---------------------------------- */ 
let isBubbling = false;

document.addEventListener("scroll", () => {
  if (isBubbling) return; // 多発防止
  isBubbling = true;

  const bubblesContainer = document.querySelector(".bubbles");
  const bubbleCount = 1 + Math.floor(Math.random() * 2); // 1〜2個

  for (let i = 0; i < bubbleCount; i++) {
    const bubble = document.createElement("div");
    bubble.classList.add("bubble");

    // 📱 画面幅によってサイズと線の太さを変える
    const isSp = window.innerWidth <= 768;
    const sizes = isSp ? [40, 80] : [60, 116];
    const borderWidth = isSp ? 7 : 10;

    const size = sizes[Math.floor(Math.random() * sizes.length)];
    bubble.style.width = `${size}px`;
    bubble.style.height = `${size}px`;
    bubble.style.left = `${Math.random() * 100}%`;
    bubble.style.borderWidth = `${borderWidth}px`;
    bubble.style.animationDuration = `${4 + Math.random() * 2}s`;
    bubble.style.animationDelay = `${Math.random() * 0.8}s`;

    bubblesContainer.appendChild(bubble);

    // 終了後削除
    setTimeout(() => bubble.remove(), 6000);
  }

  // 次の発生まで間を空ける
  setTimeout(() => {
    isBubbling = false;
  }, 1500);
});



/* ----------------------------------
　キャッチコピー
---------------------------------- */ 
window.addEventListener('load', () => {
  const copyWrap = document.querySelector('.index_mv_copy_wrap');

  // ローディング後にふわっと出現
  setTimeout(() => {
    copyWrap.classList.add('is-show');
  }, 500); // 少し余韻をつけて
});


/* ----------------------------------
　HOME　Service
---------------------------------- */ 
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".front_service_content");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // 順番に少しずつ遅れて表示
          setTimeout(() => {
            entry.target.classList.add("is-show");
          }, index * 300);

          // 一度だけ発火したい場合
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.3, // 要素の30%が見えたら発火
    }
  );

  items.forEach((item) => observer.observe(item));
});


/* ----------------------------------
　Service　その他の事業　投稿無しの場合
---------------------------------- */ 
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector('.service_other')) {

    // wave-inner01 を消す
    const wave = document.querySelector('.service_owner .wave-inner01');
    if (wave) {
      wave.style.display = 'none';
    }

    // service_owner_detail の padding-bottom を 0 にする
    const ownerDetail = document.querySelector('.service_owner_detail');
    if (ownerDetail) {
      ownerDetail.style.paddingBottom = '0';
    }
  }

});